import { cn } from "@/lib/utils";

type CarouselDotsProps = {
  count: number;
  activeIndex: number;
  onSelect: (index: number) => void;
  className?: string;
};

/**
 * Seitenanzeige fuer Karussells: der aktive Eintrag ist ein Balken (32px),
 * die anderen sind Punkte (8px). Abstaende per Rand statt `gap` (iOS 14).
 */
const CarouselDots = ({ count, activeIndex, onSelect, className }: CarouselDotsProps) => {
  if (count <= 1) return null;

  return (
    <div className={cn("flex items-center [&>*+*]:ml-1", className)}>
      {Array.from({ length: count }, (_, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onSelect(i)}
          aria-label={`Zu Eintrag ${i + 1} springen`}
          aria-current={i === activeIndex ? "true" : undefined}
          className={cn(
            "h-2 rounded-full transition-all duration-300",
            i === activeIndex ? "w-8 bg-sky-100" : "w-2 bg-white",
          )}
        />
      ))}
    </div>
  );
};

export { CarouselDots };
